import oauth2RouterPaths from './oauth2RouterPaths';

export default oauth2RouterPaths;
